module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "tracking-sec bg-full",
    staticStyle: {
      "background-image": "url('static/images/koel_frys.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-4"
  }, [_c('div', {
    staticClass: "track-holder bg-full",
    staticStyle: {
      "background-image": "url('static/images/img03.jpg')"
    }
  }, [(!_vm.contactSuccess) ? _c('div', {
    staticClass: "track-form",
    attrs: {
      "action": "#"
    }
  }, [_c('fieldset', [_c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Skal vi ringe dig op?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phonenumber),
      expression: "phonenumber"
    }],
    staticClass: "form-control md-round",
    staticStyle: {
      "color": "#000",
      "font-style": "normal"
    },
    attrs: {
      "type": "text",
      "placeholder": "Indtast dit telefonnummer"
    },
    domProps: {
      "value": (_vm.phonenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phonenumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Vi bestræber os på at kontakte dig inden for 2 arbejdsdage.")]), _vm._v(" "), _c('button', {
    staticClass: "call-button btn-primary text-center text-uppercase md-round",
    on: {
      "click": _vm.callMe
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tRING MIG OP\n\t\t\t\t\t\t\t\t\t\t\t  "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])])]) : _c('div', [_c('b', [_vm._v("Tak!")]), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\tVi kontakter dig snarest.\n\t\t\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7691807a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/promo.vue
// module id = 270
// module chunks = 1